<div class="cell">
	<span class="md-text-xs-medium">Invoice Pay Period</span>

	@if (isAdmin()) {
		<md-icon (click)="isOpen.set(!isOpen())">keyboard_arrow_down</md-icon>
	}
</div>

@if (isOpen()) {
	<md-content-box class="filter-container" lbClickOutside (clickOutside)="isOpen.set(false)">
		<div class="top-area">
			<div class="md-text-sm-semibold">Invoice Pay Period</div>

			<button md-button-link (click)="clearFilterSelectedOptions()" class="md-text-sm-semibold">Clear</button>
		</div>

		<div class="content">
			<div class="checkbox-field">
				<label>Current Pay Period</label>
				<input md-form-input [checked]="selectedIsCurrentPayPeriod()" type="checkbox" (change)="setCurrentPayPeriod($event)" />
			</div>

			<lb-form-field>
				<label>Pay Period</label>
				<md-drop-down [options]="payPeriodOptions()" [value]="selectedPayPeriodID()" (change)="setPayPeriod($event)"></md-drop-down>
			</lb-form-field>
		</div>
	</md-content-box>
}
